
import './TeamSection.scss';
import React from "react";
import { Col, Row } from 'antd';
import { MemberImg1, MemberImg2, MemberImg3, MemberImg4, MemberImg5, MemberImg6, Member1, Member2, Member3, Member4, Member5 } from "@images";

interface iPropos {
   isMobile: boolean;
}
  
function TeamSection() {

    return (
        <>
            <div className='team-container pad-l-r-24'>
                <h3 className="heading">Bowhead Leadership Team</h3>
                <Row gutter={20} justify="center">
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card first-card">
                            <div className="avatar">
                                <img src={MemberImg1} alt="" />
                            </div>
                            <h3 className="name">Francisco Diaz-Mitoma Jr.</h3>
                            <p className="position">Bowhead CEO & Co-founder</p>
                        </div>
                        <p className="description">Francisco is a software architect, product designer and serial entrepreneur. Francisco previously founded Titan Gaming, Playsino and Revenue.com. Francisco is the former Chief Software architect at Xfire, the first in-game chat application that amassed 14 million+ users. Francisco is based in Tallinn, Estonia.</p>
                    </Col>
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card second-card">
                            <div className="avatar">
                                <img src={MemberImg2} alt="" />
                            </div>
                            <h3 className="name">Dr. Rhea Mehta</h3>
                            <p className="position">Bowhead Head of Partnerships
                                & Co-founder</p>
                        </div>
                        <p className="description">Rhea is a molecular toxicologist and health coach. Rhea previously worked at Advanced Medical Research Institute of Canada (Health Sciences North) and is on the advisory board fo health analytics at McGill University. Rhea is based in Toronto, Canada.</p>
                    </Col>
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card third-card">
                            <div className="avatar">
                                <img src={MemberImg3} alt="" />
                            </div>
                            <h3 className="name">Dr. Francisco Diaz-Mitoma</h3>
                            <p className="position">Bowhead Chairman &
                                Co-founder</p>
                        </div>
                        <p className="description">Francisco is a Canadian board-certified medical doctor and virologist. Francisco is a former professor at University of Ottawa and founder of VBI Vaccines (NASDAQ: VBIV). Francisco is based in Kanata, Canada.</p>
                    </Col>
                </Row>
                <Row gutter={20} justify="center">
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card fourth-card">
                            <div className="avatar">
                                <img src={MemberImg4} alt="" />
                            </div>
                            <h3 className="name">Cesar Diaz</h3>
                            <p className="position">Bowhead CTO, Full stack
                                blockchain engineer</p>
                        </div>
                        <p className="description">Cesar is a blockchain engineer, open source contributor and evangelist in Privacy by Design. Cesar has over 20 years of experience developing highly scalable, redundant and secure systems in enterprise systems.</p>
                    </Col>
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card fifth-card">
                            <div className="avatar">
                                <img src={MemberImg5} alt="" />
                            </div>
                            <h3 className="name">Dante Sanchez</h3>
                            <p className="position">Head of Bowhead Game Studio</p>
                        </div>
                        <p className="description">Dante has over 13 years of experience building engaging game experiences. Dante has an MBA and teaches Business Administration. Previously Dante worked as a Product Manager for Gameloft working on games for Nintendo Switch and mobile.</p>
                    </Col>
                    <Col span={6} md={12} xl={6} xxl={6} xs={24}>
                        <div className="card six-card">
                            <div className="avatar">
                                <img src={MemberImg6} alt="" />
                            </div>
                            <h3 className="name">Frank Rodriguez</h3>
                            <p className="position">Bowhead Lead Game Designer</p>
                        </div>
                        <p className="description">Frank has over 15 years of game experience developing stories and building immersive worlds. Frank has been a game designer on x, y, z games. </p>
                    </Col>
                </Row>
            </div>
            <div className="medical-container pad-l-r-24">
                <h3 className="heading">Medical Advisory Team</h3>
                <div className="medical-team">
                    <div className='medical-team-container'>
                        <div className="text-center">
                            <div className="avatar">
                                <img src={Member1} alt="" />
                            </div>
                            <p className="name">Dr. Sri
                                Mummaneni</p>
                        </div>
                        <div className="text-center">
                            <div className="avatar">
                                <img src={Member2} alt="" />
                            </div>
                            <p className="name">Dr. Bruce
                                Yacyshyn</p>
                        </div>
                        <div className="text-center">
                            <div className="avatar">
                                <img src={Member3} alt="" />
                            </div>
                            <p className="name">Dr. Michael
                                Kim</p>
                        </div>
                        <div className="text-center">
                            <div className="avatar">
                                <img src={Member4} alt="" />
                            </div>
                            <p className="name">Dr. Heather
                                Woolery Lloyd</p>
                        </div>
                        <div className="text-center">
                            <div className="avatar">
                                <img src={Member5} alt="" />
                            </div>
                            <p className="name">Dr. Jeff
                                Bruce</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TeamSection;
